"use strict";

import { openModalDialog } from "./common";

const FACEBOOK_APP_ID = '324852566296054';
const GOOGLE_ID = '453330390688-3b4el8ek3j5rbuo481auqig2overvj88.apps.googleusercontent.com';

export function loadFacebookSdk(forceLoad) {
    if (!forceLoad && $('body').hasClass('signed-in') && !window.location.href.includes('/user')) {
        return;
    }
    $.ajaxSetup({ cache: true });
    $.getScript('https://connect.facebook.net/en_US/sdk.js', function(){
        FB.init({
            appId: FACEBOOK_APP_ID,
            cookie  : true,  // enable cookies to allow the server to access the session
            oauth   : true,
            xfbml   : false,  // disable xfbml improves the page load time
            status  : true,
            version: 'v13.0', // or v2.1, v2.2, v2.3, ...
        });
        getFbSignInStatus();
    });
}

export function getFbSignInStatus() {
    FB.getLoginStatus(function(response) {
        // status: 'connected',
        // authResponse: {
        //     accessToken: '...',
        //     expiresIn:'...',
        //     signedRequest:'...',
        //     userID:'...'
        // }
        if (response.status === 'connected') {
            // The user is logged in and has authenticated your
            // app, and response.authResponse supplies
            // the user's ID, a valid access token, a signed
            // request, and the time the access token
            // and signed request each expire.
            const uid = response.authResponse.userID;
            const accessToken = response.authResponse.accessToken;
        } else if (response.status === 'not_authorized') {
            // The user hasn't authorized your application.  They
            // must click the Login button, or you must call FB.login
            // in response to a user gesture, to launch a login dialog.
        } else {
            // The user isn't logged in to Facebook. You can launch a
            // login dialog with a user gesture, but the user may have
            // to log in to Facebook before authorizing your application.
        }
        console.log('fbSignInStatus', response.status);
        return response.status;
    });
}

export function getFbUserInfo(userId) {
    FB.api(
        '/'+userId+'/?fields=id,name,email',
        'GET',
        {},
        function(response) {
            console.log('getFbUserInfo', response);
            // let email = response.email;
        }
    );
}

export function facebookSignIn() {
    FB.login(function(response) {
        if (response.authResponse) {
            console.log('Welcome! Fetching your information.... ');
            FB.api('/me?fields=first_name,email,last_name,name', function (user) {
                registerFbSession(user);
            });
        } else {
            console.log('User cancelled login or did not fully authorize.');
        }
    }, {scope: 'public_profile,email'});
}

export function registerFbSession(user) {
    const http = new XMLHttpRequest();
    http.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
            if ($('#sign-in-modal, #sign-up-modal').find('.checkout-as-guest').hasClass('active')) {
                window.location.href = '/ro/checkout/new-order';
            } else {
                location.reload();
            }
        }
    };
    http.open("POST", "/ajax/registerfbuser", true);
    http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    http.send("response=" + JSON.stringify(user));
}

export function facebookSignOut(reload = true) {
    console.log('fb log out');
    if (!FB) {
        loadFacebookSdk(true);
    }
    FB?.logout();
    if (reload) {
        window.location.href = '/user/logout';
    }
}


export function loadGooglePlatform(forceLoad) {
    if (!forceLoad && $('body').hasClass('signed-in') && !window.location.href.includes('/user')) {
        return;
    }
    $.ajaxSetup({ cache: true });
    $.getScript('https://apis.google.com/js/platform.js', function(){
        gapi.load('auth2', function() {
            /* Ready. Make a call to gapi.auth2.init or some other API */
            gapi.auth2.init({
                client_id: GOOGLE_ID,
            }); // then promise - doesn't work here
        });
    });
}

export function googleSignIn() {
    const auth2 = gapi.auth2.getAuthInstance();
    auth2.signIn({
        prompt: 'select_account',
        scope: 'profile email',
        ux_mode: 'popup',
    }).then((response) => {
        console.log('User signed in via google.', response);
        registerGoogleSession(googleGetUserInfo());
    });
}

export function googleSignInStatus() {
    const auth2 = gapi.auth2.getAuthInstance();
    const signedIn = auth2.isSignedIn.get();
    console.log('googleSignInStatus', signedIn);
    return signedIn;
}

export function googleGetUserInfo() {
    const auth2 = gapi.auth2.getAuthInstance();
    const currentUser = auth2.currentUser.get();
    const profile = currentUser.getBasicProfile();
    if (!profile) {
        console.log('googleGetUserInfo', null);
        return null;
    }
    const currentUserInfo = {
        email: profile.getEmail(),
        name: profile.getName(),
        token: currentUser.getAuthResponse().id_token,
        givenName: profile.getGivenName(),
        familyName: profile.getFamilyName(),
        imageUrl: profile.getImageUrl(),
    }
    console.log('googleGetUserInfo', currentUserInfo);
    return currentUserInfo;
}

export function registerGoogleSession(user) {
    const http = new XMLHttpRequest();
    const {email, name, token} = user;
    http.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
            if ($('#sign-in-modal, #sign-up-modal').find('.checkout-as-guest').hasClass('active')) {
                window.location.href = '/ro/checkout/new-order';
            } else {
                location.reload();
            }
        }
    };
    http.open("POST", "/ajax/registergoogleuser", true);
    http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    http.send("response=" + JSON.stringify({email, name, token}));
}

export function googleSignOut(reload = true) {
    if (!gapi?.auth2) {
        loadGooglePlatform(true);
    }
    const auth2 = gapi?.auth2?.getAuthInstance();
    if (!auth2?.isSignedIn.get()) {
        return;
    }
    auth2?.signOut().then((response) => {
        console.log('User signed out via google', response);
        if (reload) {
            window.location.href = '/user/logout';
        }
    });
}

export function openSignInModal() {
    checkIfSignInSignUpFromCart()
    openModalDialog(undefined, 'sign-in-modal');
}


export function checkIfSignInSignUpFromCart() {
    const pathName = window.location.pathname;
    const fromCart = pathName.includes('user/login-for-cart')
        || pathName.includes('user/register-from-cart')
        || pathName.includes('checkout/new-order');
    $('#sign-in-modal .checkout-as-guest').toggleClass('active', fromCart);
}

export function setSignInValidator() {
    window.signInValidator = jQuery("#sign-in-form").validate({
        // Specify validation rules
        rules: {
            email: {
                required: true,
                email: true
            },
            password: {
                required: true,
            },
        },
        // Specify validation error messages
        messages: {
            email: {
                required: 'Vă rugăm să introduceți adresa de e-mail',
                email: 'Email-ul este greșit',
            },
            password: {
                required: 'Vă rugăm să introduceți o parolă',
            },
        },
        debug: false,
        focusInvalid: false,
        submitHandler: function(form, event) {
            console.log('form is valid, and handler fired', form, event);
            // if(form.valid()) {
            // }
            // submitForm(event);
            form.submit(event);
        },
        invalidHandler: function(form, event) {
            console.log('invalid form was not submitted');
        }
    });
}

export function onSubmitSignInForm() {
    $('#sign-in-form').submit();
}

export function submitSignInForm(e) {
    e?.preventDefault();

    const form = $('.sign-in-modal #sign-in-form');
    if (!form.valid()) {
        return;
    }

    const email = form.find("#sign-in-form-email").val()?.trim();
    const password = form.find("#sign-in-form-password").val()?.trim();

    const http = new XMLHttpRequest();
    const body = new FormData();
    body.append('username', email || '');
    body.append('password', password || '');

    const url = '/ro/user/login';
    http.open("POST", url, true);

    http.onreadystatechange = function () {
        if (http.readyState === 4) {
            if (http.response.indexOf('Error') > -1) {
                console.log('Sign In Submit Error', http.response);
            } else {
                console.log('Sign In Submit Success');
                if (http.responseURL !== url) {
                    location.href = http.responseURL;
                } else {
                    location.reload();
                }
            }
        }
    }

    http.onerror = function() {
        $('#fetching-error-container').text('Fetching empty meeting slots error');
    }

    http.send(body);
}

export function openSignUpModal() {
    openModalDialog(undefined, 'sign-up-modal');
}

export function setSignUpValidator() {
    window.signUpValidator = jQuery("#sign-up-form").validate({
        // Specify validation rules
        rules: {
            name: {
                required: true,
            },
            email: {
                required: true,
                email: true
            },
            password: {
                required: true,
                minlength: 8,
            },
            repassword: {
                required: true,
                equalTo : '#sign-up-form [name="password"]',
                minlength: 8,
            },
            subscription: {
            },
        },
        // Specify validation error messages
        messages: {
            name: {
                required: 'Te rugăm să introduci numele și prenumele',
            },
            email: {
                required: 'Te rugăm să introduci adresa de email',
                email: 'Email-ul este greșit',
            },
            password: {
                required: 'Te rugăm să introduci parola',
                minlength: 'Lungimea minimă trebuie să fie de 8 caractere',
            },
            repassword: {
                required: 'Te rugăm să introduci parola încă o dată',
                equalTo : 'Parola repetată nu se potrivește cu parola',
                minlength: 'Lungimea minimă trebuie să fie de 8 caractere',
            },
            subscription: {
            },
        },
        debug: false,
        focusInvalid: false,
        submitHandler: function(form, event) {
            console.log('form is valid, and handler fired', form, event);
            // if(form.valid()) {
            // }
            // submitForm(event);
            form.submit(event);
        },
        invalidHandler: function(form, event) {
            console.log('invalid form was not submitted');
        }
    });
}

export function onSubmitSignUpForm() {
    $('#sign-up-form').submit();
}

export function submitSignUpFormAjax(e) {
    e?.preventDefault();

    const form = $('.sign-up-modal #sign-up-form');
    if (!form.valid()) {
        return;
    }

    const name = form.find("#sign-up-form-name").val()?.trim();
    const email = form.find("#sign-up-form-email").val()?.trim();
    const password = form.find("#sign-up-form-password").val()?.trim();
    const passwordRepeat = form.find("#sign-up-form-password-repeat").val()?.trim();
    const subscription = form.find("#sign-up-form-subscription").val()?.trim();

    const http = new XMLHttpRequest();
    const body = new FormData();
    body.append('name', name || '');
    body.append('email', email || '');
    body.append('password', password || '');
    body.append('repassword', passwordRepeat || '');
    body.append('subscription', subscription || '');

    const url = '/ro/user/savenewuser';
    http.open("POST", url, true);

    http.onreadystatechange = function () {
        if (http.readyState === 4) {
            if (http.response.indexOf('Error') > -1) {
                console.log('Sign Up Submit Error', http.response);
            } else {
                console.log('Sign Up Submit Success');
                location.reload();
                // if (http.responseURL !== url) {
                //     location.href = http.responseURL;
                // } else {
                //     location.reload();
                // }
            }
        }
    }

    http.onerror = function() {
        console.log('Sign Up Submit Error');
    }

    http.send(body);
}

// Reset Password  - change request

export function setResetPasswordValidator() {
    window.resetPasswordValidator = jQuery("#reset-password-form").validate({
        // Specify validation rules
        rules: {
            email: {
                required: true,
                email: true
            },
        },
        // Specify validation error messages
        messages: {
            email: {
                required: 'Te rugăm să introduci adresa de email',
                email: 'Email-ul este greșit',
            },
        },
        debug: false,
        focusInvalid: false,
        submitHandler: function(form, event) {
            console.log('form is valid, and handler fired', form, event);
            // if(form.valid()) {
            // }
            // submitForm(event);
            form.submit(event);
        },
        invalidHandler: function(form, event) {
            console.log('invalid form was not submitted');
        }
    });
}

export function onSubmitResetPasswordForm() {
    $('#reset-password-form').submit();
}

export function submitResetPasswordFormAjax(e) {
    e?.preventDefault();

    const form = $('.reset-password-modal #reset-password-form');
    if (!form.valid()) {
        return;
    }

    const email = form.find("#reset-password-form-email").val()?.trim();

    const http = new XMLHttpRequest();
    const body = new FormData();
    body.append('email', email || '');

    const url = '/ro/user/reset-password';
    http.open("POST", url , true);

    http.onreadystatechange = function () {
        if (http.readyState === 4) {
            if (http.response.indexOf('Error') > -1) {
                console.log('Sign Up Submit Error', http.response);
            } else {
                console.log('Sign Up Submit Success');
                if (http.responseURL !== url) {
                    location.href = http.responseURL;
                } else {
                    location.href='ro/user/emailsent';
                }
            }
        }
    }

    http.onerror = function() {
        console.log('Reset Password Submit Error');
    }

    http.send(body);
}


// Reset Password - set new password

export function setResetPasswordSetNewPasswordValidator() {
    window.resetPasswordValidator = jQuery("#reset-password-set-new-password-form").validate({
        // Specify validation rules
        rules: {
            newpassword: {
                required: true,
                minlength: 8,
            },
            newpassword2: {
                required: true,
                equalTo : '#reset-password-set-new-password-form [name="newpassword"]',
                minlength: 8,
            },
        },
        // Specify validation error messages
        messages: {
            newpassword: {
                required: 'Te rugăm să introduci parola',
                minlength: 'Lungimea minimă trebuie să fie de 8 caractere',
            },
            newpassword2: {
                required: 'Te rugăm să introduci parola încă o dată',
                equalTo : 'Parola repetată nu se potrivește cu parola',
                minlength: 'Lungimea minimă trebuie să fie de 8 caractere',
            },
        },
        debug: false,
        focusInvalid: false,
        submitHandler: function(form, event) {
            console.log('form is valid, and handler fired', form, event);
            // if(form.valid()) {
            // }
            // submitForm(event);
            form.submit(event);
        },
        invalidHandler: function(form, event) {
            console.log('invalid form was not submitted');
        }
    });
}

export function onSubmitResetPasswordSetNewPasswordForm() {
    $('#reset-password-set-new-password-form').submit();
}

export function submitResetPasswordSetNewPasswordFormAjax(e) {
    e?.preventDefault();

    const form = $('.reset-password-set-new-password-modal #reset-password-set-new-password-form');
    if (!form.valid()) {
        return;
    }

    const password = form.find("reset-password-set-new-password-form-password").val()?.trim();
    const passwordRepeat = form.find("reset-password-set-new-password-form-password-repeat").val()?.trim();
    const hashlink = form.find("reset-password-set-new-password-form-hash-link").val()?.trim();


    const http = new XMLHttpRequest();
    const body = new FormData();
    body.append('newpassword', password || '');
    body.append('newpassword2', passwordRepeat || '');
    body.append('hashlink', hashlink || '');

    const url = '/ro/user/reset-password-save';
    http.open("POST", url, true);

    http.onreadystatechange = function () {
        if (http.readyState === 4) {
            if (http.response.indexOf('Error') > -1) {
                console.log('Sign Up Submit Error', http.response);
            } else {
                console.log('Sign Up Submit Success');
                if (http.responseURL !== url) {
                    location.href = http.responseURL;
                } else {
                    location.reload();
                }
            }
        }
    }

    http.onerror = function() {
        console.log('Reset Password Submit Error');
    }

    http.send(body);
}

export function signOut(reload = true) {
    const http = new XMLHttpRequest();
    http.open("GET", '/ro/user/logout', true);

    http.onreadystatechange = function () {
        if (http.readyState === 4) {
            if (http.response.indexOf('Error') > -1) {
                console.log('Sign Out Submit Error', http.response);
            } else {
                console.log('Sign Out Submit Success');
                if (reload) {
                    window.location.href = '/';
                }
            }
        }
    }

    http.onerror = function() {
        console.log('Sign Out Error');
    }

    http.send();

}

export function signOutAll() {
    facebookSignOut(false);
    googleSignOut(false);
    signOut(true);
}

export default function init() {
    loadFacebookSdk();
    loadGooglePlatform();

    const body = $('body');
    body.on('click', '.sign-in-modal .social-sign-in__button--facebook', facebookSignIn);
    body.on('click', '.sign-in-modal .social-sign-in__button--google', googleSignIn);
    body.on('click', '.sign-up-modal .social-sign-up__button--facebook', facebookSignIn);
    body.on('click', '.sign-up-modal .social-sign-up__button--google', googleSignIn);
    body.on('click', '.header__actions .profile .profile__logout', signOutAll);

    setSignInValidator();
    // $('.sign-in-modal .sign-in-button').on('click', onSubmitSignInForm)
    // $(".sign-in-modal #sign-in-form").submit(submitSignInForm);

    setSignUpValidator();
    // $('.sign-up-modal .sign-up-button').on('click', onSubmitSignUpForm)
    // $(".sign-up-modal #sign-up-form").submit(submitSignUpForm);

    setResetPasswordValidator();
    // $('.reset-password-modal .reset-password-button').on('click', onSubmitResetPasswordForm)
    // $(".reset-password-modal #reset-password-form").submit(submitResetPasswordFormAjax);

    setResetPasswordSetNewPasswordValidator();
    // $('.reset-password-set-new-password-modal .reset-password-set-new-password-button').on('click', onSubmitResetPasswordSetNewPasswordForm)
    // $(".reset-password-set-new-password-modal #reset-password-set-new-password-form").submit(submitResetPasswordSetNewPasswordFormAjax);

    checkIfSignInSignUpFromCart();
    document.addEventListener("modalDialog", function(event) {
        // console.log('modalDialog', event.detail);
        switch(event.detail?.id){
            case 'sign-in-modal':
                checkIfSignInSignUpFromCart();
                break;
        }
    });
}
